import { Settings, RotateCcw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useUIStore } from '@/store/uiStore'

// Order matches the user's spec list. `available: false` means the
// backend doesn't return data for this column yet — the toggle renders
// but cells show `—`. Toggling these on shows you the column shape and
// flags what to add to POListItem next.
export const COLUMN_OPTIONS: Array<{
  id: string
  label: string
  available: boolean
}> = [
  { id: 'supplier', label: 'Supplier name', available: true },
  { id: 'invoice_number', label: 'Invoice number', available: false },
  { id: 'supplier_order_number', label: 'Supplier order number', available: false },
  { id: 'location_to_receive', label: 'Shipping location', available: true },
  { id: 'created_date', label: 'Generated date', available: true },
  { id: 'ordered_date', label: 'Ordered date', available: true },
  { id: 'expected_delivery_date', label: 'Expected date', available: true },
  { id: 'payment_status', label: 'Payment status', available: false },
  { id: 'ship_date', label: 'Ship date', available: false },
  { id: 'payment_due_date', label: 'Payment due date', available: false },
  { id: 'received_count', label: 'Received count', available: false },
  { id: 'total_cost_base', label: 'Total cost', available: true },
]

export function ColumnSettings() {
  const { columnVisibility, setColumnVisible, resetColumnVisibility } =
    useUIStore()

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          size="sm"
          variant="ghost"
          className="h-7 w-7 p-0 text-[var(--ink-2)] hover:text-[var(--text-primary)]"
          aria-label="Column settings"
          title="Choose columns"
        >
          <Settings className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="text-xs font-semibold text-[var(--mute)] uppercase tracking-[0.06em]">
          Columns
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {COLUMN_OPTIONS.map((opt) => (
          <DropdownMenuCheckboxItem
            key={opt.id}
            checked={!!columnVisibility[opt.id]}
            onCheckedChange={(v) => setColumnVisible(opt.id, !!v)}
            onSelect={(e) => e.preventDefault()}
            className="text-xs"
          >
            <span className="flex items-center gap-1.5">
              {opt.label}
              {!opt.available && (
                <span className="text-[10px] text-[var(--mute)] italic">
                  (no data yet)
                </span>
              )}
            </span>
          </DropdownMenuCheckboxItem>
        ))}
        <DropdownMenuSeparator />
        <button
          type="button"
          onClick={resetColumnVisibility}
          className="flex w-full items-center gap-1.5 px-2 py-1.5 text-xs text-[var(--ink-2)] hover:bg-accent hover:text-[var(--text-primary)]"
        >
          <RotateCcw className="h-3 w-3" />
          Reset to defaults
        </button>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
